import { RegexConstants } from '../constants'
import formatter from '../utility/formatterUtil'

export const phone = (value) => {
  if (!value || value === '') {
    return true
  }

  value = value.includes('+1') ? value.replace('+1', '') : value

  const result = new RegExp(RegexConstants.phoneNumberTest).test(value)
  return result
}

export const maxPhoneLength = value => {
  if (!value) {
    return false
  }

  const tmpValue = formatter.stripPhoneNumber(value)
  return tmpValue.length === 10 ? true : !(tmpValue.length > 10)
}
